"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../atoms/Button/Button"));
var Confirmation_styles_1 = __importDefault(require("./Confirmation.styles"));
var Confirmation = function (_a) {
    var setStep = _a.setStep;
    return (react_1.default.createElement(Confirmation_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("h1", { className: "title" }, "Beschikbaarheid doorgeven"),
                react_1.default.createElement("p", { className: "intro" }, "Je beschikbaarheid is verwerkt en scholen kunnen zich vanaf [datum x] gaan inschrijven voor het voor hun beschikbare aanbod. Mocht je je beschikbaarheid willen aanpassen doe dat dan voor deze datum zodat er geen conflicten ontstaan."),
                react_1.default.createElement(Button_1.default, { className: "button secondary", onClick: function () { return setStep(4); } },
                    react_1.default.createElement("span", null, "Ga door"),
                    react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" })))))));
};
exports.default = Confirmation;
